module.exports = __webpack_public_path__ + "img/短信警告.b6fd0612.jpg";